import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { MultiItemOrItemWrapper } from "../../_shared/components/table/multi-level-table/multi-level-table.component";
import { BaseService } from "../../_shared/services/base.service";
import { Intrest, IntrestGroup, IntrestGroupAsMultiItem, PersonIntrest } from "../models/tasks";

@Injectable({
  providedIn: "root",
})
export class IntrestGroupService extends BaseService<IntrestGroup, IntrestGroup> {
  constructor(
    protected override http: HttpClient,
    @Inject("BASE_URL") protected override baseUrl: string
  ) {
    super(http, baseUrl, "intrestgroup");
  }

  //mijn assist
  getIntrests(orgKey: string) {
    return this.getAll(`/public?accessKey=${orgKey}`);
  }

  mapIntrestsToMultiItems(
    intrestGroups: IntrestGroup[],
    showAll: boolean = true,
    personIntrests?: PersonIntrest[]
  ): IntrestGroupAsMultiItem[] {
    return intrestGroups
      .map((group) => {
        return {
          ...group,
          Children: group.Intrests.map((intrest) => ({
            ...intrest,
            isSelected: (personIntrests ?? []).some(
              (personIntrest) => personIntrest.IntrestId === intrest.Id
            ),
          })).filter((intrest) => intrest.isSelected == true || showAll),
        } as IntrestGroupAsMultiItem;
      })
      .filter((group) => group.Children.length > 0 || showAll);
  }

  mapIntrestsToMultiItemWrappers(
    intrestGroups: IntrestGroup[],
    showAll: boolean = true,
    personIntrests?: PersonIntrest[]
  ): MultiItemOrItemWrapper<IntrestGroupAsMultiItem, Intrest>[] {
    return this.mapIntrestsToMultiItems(intrestGroups, showAll, personIntrests).map(
      (group) => new MultiItemOrItemWrapper<IntrestGroupAsMultiItem, Intrest>(group)
    );
  }
}
